<template>
    <div class="relative grid cursor-pointer grid-cols-3 gap-6">
        <div
            v-for="(item, index) in MENU_LIST['sport']['sportBook']"
            :key="index"
            @click="redirect(item)"
        >
            <div class="flex w-full">
                <img
                    :src="`/assets/img/menu/${item.name}.png`"
                    :alt="item.name"
                    class="flex w-full object-cover"
                />
                <img
                    v-if="item?.isHot"
                    class="absolute left-0 top-0 h-auto w-10"
                    :src="`${staticUrl}/assets/icons/hot.png`"
                    alt="hot icon"
                />
            </div>
        </div>
    </div>
</template>
<script setup>
import { MENU_LIST } from '@/constants/menu.js'
const staticUrl = useRuntimeConfig().public.staticUrl
const redirect = (item) => {
    navigateTo(item.url)
}
</script>
